import { render, staticRenderFns } from "./MessagingDashboard.vue?vue&type=template&id=2ca548d0&scoped=true"
import script from "./MessagingDashboard.vue?vue&type=script&lang=js"
export * from "./MessagingDashboard.vue?vue&type=script&lang=js"
import style0 from "./MessagingDashboard.vue?vue&type=style&index=0&id=2ca548d0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca548d0",
  null
  
)

export default component.exports